import {
  uploadMultipleFiles,
  uploadPrintingFiles,
  uploadSingleFile,
} from "./Networking";

export default class ImageAPI {
  uploadFile = async (
    file: File | null,
    container: string,
  ): Promise<string | null> => {
    try {
      if (!file) {
        throw new Error("No files provided for upload.");
      }
      const response = await uploadSingleFile(
        `/v5/images/single`,
        file,
        container,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  uploadImage = async (
    files: File[] | null,
    container: string,
  ): Promise<string[]> => {
    try {
      if (!files || files.length === 0) {
        throw new Error("No files provided for upload.");
      }
      const response = await uploadMultipleFiles(
        `/v5/images/product/multiple`,
        files,
        container,
      );
      return response.result as string[];
    } catch (error) {
      throw error;
    }
  };

  uploadVideo = async (
    files: File[] | null,
    container: string,
  ): Promise<string[]> => {
    try {
      if (!files || files.length === 0) {
        throw new Error("No files provided for upload.");
      }

      const response = await uploadMultipleFiles(
        `/v5/images/videos`,
        files,
        container,
      );

      return response.result as string[];
    } catch (error) {
      throw error;
    }
  };

  uploadCdr = async (files: File[] | null): Promise<string[]> => {
    try {
      if (!files || files.length === 0) {
        throw new Error("No files provided for upload.");
      }

      const response = await uploadPrintingFiles(
        `/v5/images/printing-file`,
        files,
      );

      return response.result as string[];
    } catch (error) {
      throw error;
    }
  };

  uploadWebpImages = async (
    files: File[] | null,
    container: string = "event-management",
  ): Promise<string[]> => {
    try {
      if (!files || files.length === 0) {
        throw new Error("No files provided for upload.");
      }
      const response = await uploadMultipleFiles(
        `/v5/images/multiple/webp`,
        files,
        container,
      );
      return response.result as string[];
    } catch (error) {
      throw error;
    }
  };

  uploadVendorDocuments = async (
    files: File[] | null,
    container: string = "vendor-documents",
  ): Promise<string[]> => {
    try {
      if (!files || files.length === 0) {
        throw new Error("No files provided for upload.");
      }
      const response = await uploadMultipleFiles(
        `/v5/images/vendor/multiple`,
        files,
        container || "vendor-documents",
      );
      return response.result as string[];
    } catch (error) {
      throw error;
    }
  };
}
